import { render } from "./ImageSelectorInput.vue?vue&type=template&id=ab678828&scoped=true"
import script from "./ImageSelectorInput.vue?vue&type=script&lang=js"
export * from "./ImageSelectorInput.vue?vue&type=script&lang=js"

import "./ImageSelectorInput.vue?vue&type=style&index=0&id=ab678828&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab678828"]])

export default __exports__